import { currentRqProduct } from '../utils/rqProduct'
export const ENROLEMENT_ENDPOINT = 'https://certificats.cnfr.api.rq-fo.ca/enrolement'
export const CERT_ENDPOINT = 'https://cnfr.api.rq-fo.ca/certificats'
export const USER_ENDPOINT = 'https://cnfr.api.rq-fo.ca/utilisateur'
export const TRANSACTION_ENDPOINT = 'https://cnfr.api.rq-fo.ca/transaction'
export const DOCUMENT_ENDPOINT = 'https://cnfr.api.rq-fo.ca/document'


export const ENROLEMENT_ENDPOINT_PROD = 'https://certificats.api.rq-fo.ca/enrolement'
export const CERT_ENDPOINT_PROD = 'https://api.rq-fo.ca/certificats'
export const USER_ENDPOINT_PROD = 'https://api.rq-fo.ca/utilisateur'
export const TRANSACTION_ENDPOINT_PROD = 'https://api.rq-fo.ca/transaction'
export const DOCUMENT_ENDPOINT_PROD = 'https://api.rq-fo.ca/document'
// Common Headers
// Common Headers
export const getCommonHeaders = (envirn = 'DEV', caseEssai = '001.001', idapprl = '0000000000000001') => {
  const product = currentRqProduct()
  return ({
  'Content-Type': 'application/json',
  ENVIRN: envirn,
  CASESSAI: caseEssai,
  APPRLINIT: product.APPRLINIT,
  IDAPPRL: idapprl || '0000-0000-0000',
  IDSEV: product.IDSEV,
  IDVERSI: product.IDVERSI,
  CODCERTIF: product.CODCERTIF,
  IDPARTN: product.IDPARTN,
  VERSI: product.VERSI,
  VERSIPARN: product.VERSIPARN
  })
}


// Certificate Replacement Constants
export const ADD_DEFAULTS = {
  modif: 'AJO',
  CASESSAI: '001.001'
}
// Certificate Replacement Constants
export const REPLACEMENT_DEFAULTS = {
  modif: 'REM',
  CASESSAI: '001.002'
}

// Certificate Deletion Constants
export const DELETION_DEFAULTS = {
  modif: 'SUP',
  CASESSAI: '001.003'
}

// User Management Constants
export const USER_DEFAULTS = {
  createModif: 'AJO',
  deleteModif: 'SUP',
  createCASESSAI: '002.001',
  deleteCASESSAI: '002.002'
}

// Document Request Constants
export const DOCUMENT_DEFAULTS = {
  userReportType: 'RUT',
  userReportCASESSAI: '103.001'
}

// Storage Keys
export const STORAGE_KEYS = {
  CERTIFICATES: 'certificates',
  CSR: 'csr',
  ENVIRONMENTS: {
    DEV: 'DEV',
    ESSAI: 'ESSAI',
    PROD: 'PROD'
  }
}